/**
 * List all possible commands the system is capable of processing.
 */
export enum CommunicationWorkerName {
  user = 'user',
  event = 'event',
}

export type CommunicationWorkerNameType = keyof typeof CommunicationWorkerName;
